import { createFlightResultsProps } from '../funnels/FlightResults/integration/flightResults.props';
export const createAppProps = ({
  flightResults
}) => ({
  flightResultsProps: createFlightResultsProps(flightResults)
});